















































import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { kebabCase } from 'lodash'
import { mapGetters } from 'vuex'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import { ProfileStubState } from './BuilderProfile.vue'
import BuilderDot from '@/components/builder/BuilderDot.vue'
import { App } from '@/services/types'

@Component({
  components: {
    BuilderButton,
    BuilderTooltip,
    BuilderDot,
  },
  computed: {
    ...mapGetters('builder', { app: 'getApp' }),
  },
})
export default class BuilderProfilePageName extends Vue {
  @Prop({ required: true, type: Object }) readonly value!: ProfileStubState

  @Prop({ required: true, type: Number }) readonly step!: number

  @Ref('input') input!: HTMLInputElement

  app!: App | null

  processing = false

  validationErrors = false

  get appCurrency(): string {
    return this.value.currency ?? ''
  }
  get pageName(): string {
    return this.value.siteName ?? ''
  }

  set pageName(siteName: string) {
    this.$emit('input', { siteName })
  }

  get isNextStepDisabled(): boolean {
    return !this.pageName || this.appSelectedType === 'NONE'
  }
  get appCurrencyType(): string {
    return this.$store.getters['builder/getAppCurrencyType']
  }
  set appCurrencyType(value: string) {
    this.$store.commit('builder/setAppCurrencyType', value)
  }

  get appSelectedType(): string {
    return this.$store.getters['builder/getAppSelectedType']
  }

  set appSelectedType(value: string) {
    this.$store.commit('builder/setAppSelectedType', value)
    if (value !== 'NONE') {
      this.$store.commit('builder/setAppType', value)
    } else {
      this.$store.commit('builder/setAppType', 'TYPE_BLOGER')
    }
  }

  async onNextClick(): Promise<void> {
    if (this.isNextStepDisabled) {
      return
    }
    if (this.app) {
      this.$emit('next')
      return
    }
    this.processing = true
    if (this.validateAppName(this.pageName)) {
      try {
        await this.$store.dispatch('builder/setProfileName', {
          name: this.pageName,
        })

        this.$emit('next')
      } catch ({ message }: unknown) {
        this.$toasted.error(String(message))
      }
    } else {
      this.validationErrors = true
    }

    this.processing = false
  }

  // eslint-disable-next-line class-methods-use-this
  validateAppName(name: string): boolean {
    if (!/^[a-z0-9A-Z\-\\.\\_]*$/.test(name)) {
      this.$toasted.error(String(this.$t('errors.pageName.symbols')))
      return false
    }

    if (name.length > 30) {
      this.$toasted.error(String(this.$t('errors.pageName.count')))
      return false
    }

    return true
  }

  async mounted(): Promise<void> {
    this.$emit('input', {
      highlight: 'header',
      blurProfile: true,
      blurCover: true,
      blurSubscriptions: true,
      blurContentType: true,
      blurPosts: true,
    })

    this.input.focus()
  }
}
